import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import CollectionsList from "./CollectionsList";
import PageNotFound from "../pageNoFound";
import AddCollection from "./AddCollection";
import EditCollection from "./EditCollection";
import ViewCollection from "./ViewCollection";
import AllowedAccess from "../../Layout/AllowedAccess";
import ErrorBoundry from "../../Services/ErrorBoundry";

const canAccessCollections = (userData) => (
    userData.role_slug === "super_admin"
    || userData.caps_list.includes("manage_collections")
    || userData.caps_list.includes("view_collections")
    || userData.caps_list.includes("add_collection")
    || userData.caps_list.includes("edit_collection")
    || userData.caps_list.includes("submit_collection_payment")
);

const CollectionsRoutes = () => {
    const { userData } = useSelector((state) => state.user);

    if (!canAccessCollections(userData)) {
        return <ErrorBoundry />;
    }

    return (
        <Routes>
            <Route index element={<CollectionsList />} />
            <Route
                path="add"
                element={
                    <AllowedAccess
                        role={userData.role_slug}
                        allowedRoles={["super_admin"]}
                        allowedPermissions={["add_collection", "manage_collections"]}
                        userPermissions={userData.caps_list}
                        renderNoAccess={() => <ErrorBoundry />}
                        children={<AddCollection />}
                    />
                }
            />
            <Route
                path="edit"
                element={
                    <AllowedAccess
                        role={userData.role_slug}
                        allowedRoles={["super_admin"]}
                        allowedPermissions={["edit_collection", "manage_collections"]}
                        userPermissions={userData.caps_list}
                        renderNoAccess={() => <ErrorBoundry />}
                        children={<EditCollection />}
                    />
                }
            />
            <Route path="view" element={<ViewCollection />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default CollectionsRoutes;
